import * as React from 'react';
import { ReactNode } from 'react';

type FormFieldProps = {
  name: string;
  label?: string;
  children: ReactNode;
};
export default function FormField({ name, label, children }: FormFieldProps) {
  return (
    <div>
      {label && (
        <div className="row justify-content-center">
          <div className="col-10 col-lg-8">
            <label htmlFor={name} className="form-label mb-0">
              {label}
            </label>
          </div>
        </div>
      )}
      <div className="row justify-content-center mb-2">
        <div className="col-10 col-lg-8">{children}</div>
      </div>
    </div>
  );
}
